/** Sales progress is separate from the project's delivery/workflow stage. */
export const PROJECT_PIPELINE_STATUSES = ['enquiry', 'contacted', 'proposal_sent', 'won', 'lost'] as const;

export type ProjectPipelineStatus = typeof PROJECT_PIPELINE_STATUSES[number];

export const PROJECT_PIPELINE_STATUS_LABELS: Record<ProjectPipelineStatus, string> = {
  enquiry: 'Enquiry',
  contacted: 'Contacted',
  proposal_sent: 'Proposal Sent',
  won: 'Won',
  lost: 'Lost',
};

export function isProjectPipelineStatus(value: unknown): value is ProjectPipelineStatus {
  return typeof value === 'string' && PROJECT_PIPELINE_STATUSES.some(status => status === value);
}

/** Older caches and API responses may omit the newly introduced column. */
export function projectPipelineStatus(value: unknown): ProjectPipelineStatus {
  return isProjectPipelineStatus(value) ? value : 'enquiry';
}
